<template>
  <div id="resources-table" class="">
    <div class="content">
      <div v-if="resource" class="single">
        <Resource></Resource>
      </div>
      <div v-else>
        <div class="meta">
          <div class="filters">
            <v-text-field
              class="filter"
              v-model="search.search"
              append-icon="search"
              :label="$t('admin.views.resources.filter')"
              single-line
              hide-details
              style="margin-right: 30px"
            ></v-text-field>
            <v-select
              v-if="market === 'ES'"
              class="filter"
              :items="['CAST', 'CAT']"
              v-model="search.lang"
              :label="$t('admin.views.resources.language')"
              clearable
              single-line
            ></v-select>
          </div>
          <div class="buttons">
            <v-btn
              v-if="!resource && selectedIds.length > 0"
              outline
              @click="changeStatus(0)"
              color="gray"
              >{{ $t('admin.views.resources.inactive') }}</v-btn
            >
            <v-btn
              v-if="!resource && selectedIds.length > 0"
              outline
              @click="changeStatus(1)"
              color="gray"
              >{{ $t('admin.views.resources.active') }}</v-btn
            >
            <v-btn v-if="!resource" outline @click="add" color="success"
              >{{ $t('admin.views.resources.new') }}</v-btn
            >
          </div>
        </div>

        <v-data-table
          :custom-filter="filter"
          :headers="computedHeaders"
          :items="resources"
          class=""
          id="resources-table"
          :no-results-text="message_not_found"
          :rows-per-page-items="rows_per_page"
          :pagination.sync="pagination"
          :search="search"
          :must-sort="true"
          :rows-per-page-text="message_rows_per_page"
          item-key="id"
          select-all
          v-model="selected"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
                :key="props.item.id"
              ></v-checkbox>
            </td>
            <td>
              <img
                v-if="
                  (props.item.thumb != '-1' && props.item.thumb != '') ||
                    (props.item.file != '-1' && props.item.file != '')
                "
                class="image"
                :src="props.item.thumb + '?' + date(props.item.update_date)"
              />
              <v-icon v-else>cloud_upload</v-icon>
            </td>
            <td>{{ props.item.name }}</td>
            <td>
              <div v-for="section in props.item.sections">
                <template v-if="market === 'PT'">
                  {{ getBreadcrumbForSection(section) }}
                </template>
                <template v-else>
                  {{ section.name }}
                </template>
              </div>
            </td>
            <td v-if="market === 'ES'">{{ props.item.lang.name }}</td>
            <td>{{ props.item.type ? props.item.type.name : "" }}</td>
            <td>{{ props.item.status | formatStatus }}</td>
            <td>{{ props.item.update_date | moment }}</td>
            <td>
              <v-icon @click="edit(props.item)">edit</v-icon
              ><v-icon @click="remove(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Resource from "@/components/domain/admin/Resource";
import i18n from "@/i18n";

export default {
  name: "Resources",
  props: { page: String },
  components: { Resource },
  data() {
    return {
      headers: [
        { text: i18n.t('general.headers.image'), value: "thumb", width: "100px", align: "left" },
        { text: i18n.t('general.name'), value: "name", align: "left" },
        { text: i18n.t('general.headers.section'), value: "sections[0].name", align: "left" },
        { text: i18n.t('general.headers.language'), value: "lang", width: "75px", align: "left" },
        { text: i18n.t('general.headers.format'), value: "type.name", align: "left" },
        { text: i18n.t('general.status'), value: "status", width: "75px", align: "left" },
        {
          text: i18n.t('general.headers.update_date'),
          value: "update_date",
          width: "75px",
          align: "left"
        },
        { text: "", value: "actions", width: "120px", align: "right" }
      ],
      search: {},
      id: -1,
      message_not_found: i18n.t('admin.views.resources.message_not_found'),
      message_rows_per_page: i18n.t('admin.views.resources.message_rows_per_page'),
      rows_per_page: [10, 25, 50, 100, { text: "Todos", value: -1 }],
      pagination: {
        rowsPerPage: 10,
        sortBy: "update_date",
        descending: true,
        rowsPerPageItems: [20, 50, 100, -1]
      },
      selected: []
    };
  },
  computed: {
    selectedIds() {
      var ids = [];
      for (var i in this.selected) {
        ids.push(this.selected[i].id);
      }
      return ids;
    },
    resources() {
      var resources = ObjectToArray(this.$store.getters["files/getFiles"]());
      return resources.filter(r => r && r.id);
    },
    resource() {
      return this.$store.getters["files/getCurrentFile"];
    },
    market() {
      return this.$store.getters.getMarket;
    },
    computedHeaders() {
      if (this.market === 'ES') {
        return this.headers
      } else {
        return this.headers.filter(header => header.value !== 'lang');
      }
    },
    add_file() {
      return {
        id: -1,
        name: "",
        file: "",
        thumb: "",
        status: "2",
        lang: this.market === 'PT' ? { id: "L3VrYWUzY1kxUWViTTUzMHp3QnRSQT09", name: "Português" } : { id: "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09", name: "Español" },
        tags: "",
        sections: []
      };
    },
    categoryPaths() {
      const categories = this.$store.getters["files/getCategories"]();
      const paths = {};
      const roots = ObjectToArray(categories);

      const traverse = (node, acc) => {
        const currentPath = acc ? acc + ' > ' + node.name : node.name;
        paths[node.id] = currentPath;
        const children = ObjectToArray(node.childs || {});
        children.forEach(child => traverse(child, currentPath));
      };

      roots.forEach(root => traverse(root, ''));
      return paths;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    formatStatus: function(status) {
      var result = "";
      switch (status) {
        case "1":
          result = i18n.t('admin.views.resources.status.1');
          break;
        case "2":
          result = i18n.t('admin.views.resources.status.2');
          break;
        case "0":
          result = i18n.t('admin.views.resources.status.0');
          break;
        default:
          break;
      }

      return result;
    }
  },
  methods: {
    edit(file) {
      this.$store.commit("files/setCurrentFile", file);
    },
    remove(resource) {
      var self = this;
      this.$popup.confirm(
        i18n.t('admin.views.resources.popup.delete'),
        i18n.t('admin.views.resources.popup.delete_message', { name: resource.name }),
        i18n.t('general.accept'),
        i18n.t('general.cancel'),
        function() {
          self.$store.dispatch("files/removeResource", resource.id);
        }
      );
    },
    changeStatus(status) {
      var self = this;
      this.$store.dispatch("files/updateStatus", {
        files: this.selectedIds,
        status: status
      });
    },
    add() {
      console.log('add_file', this.add_file);
      this.$store.commit("files/setCurrentFile", this.add_file);
    },
    date(date) {
      return moment(date).valueOf();
    },
    filter(items, search, filter) {
      var aItems = [];
      if (search.search) {
        const normalize = function (s) {
          return (s || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        };
        const term = normalize(search.search);
        const categoryPaths = this.market === 'PT' ? this.categoryPaths : null;
        items.forEach(item => {
          const nameMatch = filter(normalize(item.name), term);
          const typeMatch = filter(normalize((item.type && item.type.name) ? item.type.name : ""), term);

          let matched = nameMatch || typeMatch;

          if (!matched) {
            (item.sections || []).some(section => {
              if (this.market === 'PT') {
                const sectionPath = normalize(categoryPaths && categoryPaths[section.id] ? categoryPaths[section.id] : section.name);
                if (filter(sectionPath, term)) {
                  matched = true;
                  return true;
                }
              } else {
                const sectionName = normalize(section.name);
                if (filter(sectionName, term)) {
                  matched = true;
                  return true;
                }
              }
              return false;
            });
          }

          if (matched) aItems.push(item);
        });
      }

      if (search.lang) {
        var searchItems =
          aItems.length == 0 &&
          (search.search == "" || typeof search.search === "undefined")
            ? items
            : aItems;
        var aItemsLang = [];
        searchItems.forEach(item => {
          if (
            filter(
              ((item.lang && item.lang.name) ? item.lang.name : "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase(),
              search.lang
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
          ) {
            aItemsLang.push(item);
          }
        });
        const seen = new Set();
        return aItemsLang.filter(it => {
          const key = it && it.id;
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }

      if (!search.lang && !search.search) {
        return items;
      } else {
        const seen = new Set();
        return aItems.filter(it => {
          const key = it && it.id;
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }
    },
    getBreadcrumbForSection(section) {
      const path = this.categoryPaths && this.categoryPaths[section.id];
      return path || section.name;
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit("setTitle", i18n.t('general.resources'));
    this.$store.commit("setMenuVisible", false);

    var self = this;
    this.$store.dispatch("files/loadCategories", {}).then(function() {
      self.$store.commit("files/selectCategory", false);
      self.$store.dispatch("files/loadFiles", {}).then(function() {
        // self.$store.commit( 'files/setUploading', self.resources[0] );
        switch (self.page) {
          case "edit":
            self.$store.commit(
              "files/setCurrentFileByID",
              self.$route.params.id
            );
            break;
          case "add":
            self.$store.commit("files/setCurrentFile", self.add_file);
            break;
          default:
            break;
        }
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}

.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px 50px;
  position: relative;

  td {
    .v-icon {
      margin-left: 5px;
    }

    .image {
      width: 100%;
    }
  }

  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .filter {
      float: left;
      width: 400px;
    }
    .buttons {
      float: right;
    }
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filters {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .filter {
        display: inline-block;
        margin-right: 20px !important;
      }

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
